import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import driverApi from "../../../apis/driverApi";

interface Props {
  open: boolean;
  handleClose: () => void;
  refresh: () => void;
  partnerId: string;
}

const ModalCreateDriver = ({ open, handleClose, refresh, partnerId }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({ name: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!formData.name || !formData.phone || !formData.password) {
      enqueueSnackbar("Vui lòng nhập đủ thông tin", { variant: "warning" });
      return;
    }

    setLoading(true);
    try {
      const payload = { ...formData, partnerId };
      const res = await driverApi.createDriver(payload);
      if (res.data.code === 0) {
        enqueueSnackbar("Thêm tài xế thành công!", { variant: "success" });
        refresh();
        handleClose();
      } else {
        enqueueSnackbar(res.data.message || "Thêm thất bại", { variant: "error" });
      }
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(err.response?.data?.message || "Lỗi khi thêm tài xế", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Thêm tài xế mới</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 15, marginTop: 10 }}>
          <TextField 
            label="Tên tài xế" 
            value={formData.name} 
            onChange={(e) => setFormData({ ...formData, name: e.target.value })} 
            fullWidth 
          />
          <TextField 
            label="Số điện thoại (Dùng để đăng nhập)" 
            value={formData.phone} 
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })} 
            fullWidth 
          />
          <TextField 
            label="Mật khẩu" 
            type="password"
            value={formData.password} 
            onChange={(e) => setFormData({ ...formData, password: e.target.value })} 
            fullWidth 
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">Hủy</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
          {loading ? "Đang thêm..." : "Thêm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCreateDriver;
